import apiUrl from "../../../constants";
import axios from "axios";
import iptrackerdetails from "../../../iptrackerdetails";
import Paginate from "vuejs-paginate";
import CryptoJS from "crypto-js";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";

export default {
  name: "verticalfunction",
  components: {
    Paginate,
    VueElementLoading,
  },
  data: function () {
    return {
      modalShow: false,
      updateverticalfunctionmodal: false,
      editverticalfunctionmodal: false,
      addverticalfunctionmodal: false,
      verticalfunctionaction: "",
      iptrackData: "",
      listverticalfunctionData: [],
      listPermissionData: [],
      permissionid: [],
      localuserid: "",
      pageno: 0,
      pagecount: 0,
      verticalfunction: "",
      searchverticalfunctionid: "",
      weightage: "",
      is_active: "true",
      perm_id: [],
      verticalfunctionid: "",
      devicetype: "",
      isLoading: false,
      resultCount: "",
      incrementResultCount: "",
      checkedPerm_Id: [],
      projectid: [],
      listProjectData: [],
      listUserTypeData: [],
      selected: "",
      verticalfunctiontype: "",
      usertypeid: 0,
      changestatus: "",
      businessverticalid: "",
      businesssubverticalid: "",
      businessverticallist: [],
      buinesssubverticallist: [],
      verticalfunction: "",
    };
  },

  created: function () {},

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail;
    this.localuserid = userdetail.userid;
    this.getverticalfunctionData();
    this.getBusinessVertical();
  },

  methods: {
    addNewverticalfunction() {
      this.verticalfunctionid = "";
      this.verticalfunction = "";
      this.verticalfunctiontype = "";
      this.projectid = [];
      this.usertypeid = "";
      this.devicetype = "";
      this.weightage = "";
      this.is_active = "true";
      this.checkedPerm_Id = [];
      this.verticalfunctionaction = "add";
      this.addverticalfunctionmodal = true;
      this.$validator.reset();
      this.errors.clear();
    },

    closeAddverticalfunctionModal() {
      $("#verticalfunctionform").trigger("reset");
      this.addverticalfunctionmodal = false;
      this.$validator.reset();
      this.errors.clear();
    },

    closeStatusverticalfunctionModal() {
      this.modalShow = false;
    },
    resetSearch() {
      this.searchverticalfunctionid = "";
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getverticalfunctionData();
    },
    resetform() {
      this.verticalfunctionid = "";
      this.verticalfunction = "";
      this.verticalfunctiontype = "";
      this.projectid = [];
      this.usertypeid = "";
      this.devicetype = "";
      this.weightage = "";
      this.is_active = "true";
      this.checkedPerm_Id = [];
      this.listPermissionData = [];
      this.permissionid = [];
      this.getverticalfunctionData();
    },

    getPermissionList() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      this.input = {
        devicetype: this.devicetype,
        projectid: this.projectid,
        is_active: this.is_active,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "permissionmaster",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.listPermissionData = result.data.data;
        },
        (error) => {
          console.error(error);
        }
      );
    },

    getverticalfunctionData() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      this.input = {
        offset: this.pageno,
        limit: 10,
        verticalfunction: "",
        pagination: true,
      };
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "GetverticalfunctionsListUM",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          console.log(result.data);
          this.listverticalfunctionData = result.data.data.rows;
          this.isLoading = false;
          let totalRows = result.data.data.count;
          this.resultCount = result.data.data.count;
          this.incrementResultCount = result.data.count + 1;
          this.weightage = this.incrementResultCount;
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }
        },
        (error) => {
          console.error(error);
        }
      );
    },

    searchverticalfunctionData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getverticalfunctionDatabySearch();
    },
    getverticalfunctionDatabySearch() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      this.input = {
        offset: this.pageno,
        limit: 10,
        verticalfunction: this.searchverticalfunctionid,
        pagination: true,
      };
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "GetverticalfunctionsListUM",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          console.log(result.data);
          this.listverticalfunctionData = result.data.data.rows;
          this.isLoading = false;
          let totalRows = result.data.data.count;
          this.resultCount = result.data.count;
          this.incrementResultCount = result.data.count + 1;
          this.weightage = this.incrementResultCount;
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }
        },
        (error) => {
          console.error(error);
        }
      );
    },
    // for vertical dropdown
    getBusinessVertical() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      this.input = {};
      axios({
        method: "POST",
        url: apiUrl.api_url + "GetBverticalslist",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.businessverticallist = result.data.data.rows;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    // for Sub vertical dropdown
    getBusinessSubVertical() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      this.input = {
        buiness_vertical_id: this.businessverticalid,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "GetBSVerticalsList",
        data: this.input,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      }).then(
        (result) => {
          this.buinesssubverticallist = result.data.data.rows;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    saveverticalfunction(event) {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      let reqpayload = {
        verticalfunction: this.verticalfunction,
        buinesssubverticalsid: this.businesssubverticalid,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "Createverticalfunctions",
        data: reqpayload,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      })
        .then((response) => {
          if (response.data.code == 200) {
            this.$alertify.success("Vertical Function created successfully");
            this.addverticalfunctionmodal = false;
            event.target.reset();
            this.resetform();
          } else if (response.data.code == 209) {
            this.$alertify.error("Vertical Function already exist");
            //this.addverticalfunctionmodal = false;
          } else if (response.data.msg == 400) {
            this.$alertify.error("Failed");
            this.addverticalfunctionmodal = false;
            this.resetform();
          }
          iptrackerdetails.checkUserIP(
            this.iptrackData,
            "Save verticalfunction",
            this.$route.path,
            reqpayload,
            response.data
          );
        })
        .catch((httpException) => {
          console.error("exception is:::::::::", httpException);
        });
    },

    getverticalfunctionRowData(data, maxWeightage) {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      this.$validator.reset();
      this.errors.clear();
      this.verticalfunctionaction = "edit";
      this.addverticalfunctionmodal = true;
      this.verticalfunctionid = data.verticalfunctionid;
      this.verticalfunction = data.verticalfunction;
      this.is_active = data.is_active;
      this.checkedPerm_Id = [];
      this.projectid = data.projectid;
      this.usertypeid = data.usertypeid;
      this.weightage = data.weightage;
      this.incrementResultCount = maxWeightage;
      this.verticalfunctiontype = data.verticalfunctiontype;
    },

    editverticalfunction(event) {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");
      var permissionid = this.checkedPerm_Id.map(Number);

      if (this.verticalfunctiontype == 1) {
        this.projectid = [];
        this.usertypeid = 0;
      }

      let reqpayload = {
        verticalfunction: this.verticalfunction.trim(),
        verticalfunctionid: this.verticalfunctionid,
        permissionid: permissionid,
        projectid: this.projectid,
        usertypeid: 0,
        is_active: this.is_active,
        weightage: this.weightage,
        verticalfunctiontype: 1,
        modifiedby: this.localuserid,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "Updateverticalfunction",
        data: reqpayload,
        headers: {
          Authorization: "Bearer " + myStr,
        },
      })
        .then((response) => {
          if (response.code == 200) {
            this.$alertify.success(
              "System verticalfunction updated successfully"
            );
            this.addverticalfunctionmodal = false;
            this.verticalfunction = "";
            event.target.reset();
            this.resetform();
          } else if (response.code == 209) {
            this.$alertify.error("System Vertical Function already exist");
            //this.addverticalfunctionmodal = false;
          } else {
            this.$alertify.error("verticalfunctions failed to update");
            this.addverticalfunctionmodal = false;
          }
          iptrackerdetails.checkUserIP(
            this.iptrackData,
            "Update verticalfunction",
            this.$route.path,
            reqpayload,
            response.data
          );
        })
        .catch((httpException) => {
          console.error("exception is:::::::::", httpException);
        });
    },

    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.getverticalfunctionData();
    },

    onSubmit: function (event) {
      // this.saveverticalfunction(event);
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            if (
              this.buinesssubverticalsid != undefined &&
              this.buinesssubverticalsid != ""
            ) {
              this.editverticalfunction(event);
            } else {
              this.saveverticalfunction(event);
            }
          }
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },

    //to get target id in active/inactive modal
    getStatusRowData(data) {
      this.Statusaction = "add";
      this.modalShow = true;
      this.verticalfunctionid = data.verticalfunctionid;
      this.is_active = data.is_active;
      if (data.is_active == true) {
        this.changestatus = "De-Activate";
      } else {
        this.changestatus = "Activate";
      }
    },

    //for active/inactive modal
    changeverticalfunctionStatus() {
      var userToken = window.localStorage.getItem("userToken");
      var myStr = userToken.replace(/"/g, "");

      axios({
        method: "POST",
        url: apiUrl.api_url + "UpdateStatus",
        data: {
          verticalfunctionid: this.verticalfunctionid,
          is_active: this.is_active,
        },
        headers: {
          Authorization: "Bearer " + myStr,
        },
      })
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.$alertify.success(response.data.msg);
            this.addverticalfunctionmodal = false;
            this.getverticalfunctionData();
          } else if (response.data.errorCode == -1) {
            this.$alertify.error(response.data.msg);
          }
        })
        .catch((httpException) => {
          console.error("exception is:::::::::", httpException);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/verticalfunction/verticalfunction.component.js